import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Toggle from '@talend/react-components/lib/Toggle';

import { I18N_NAME_SPACE } from '../../../../../constants';

export interface MandatoryProps {
	rhf: any;
	readOnly: boolean;
}

export function Mandatory({ rhf, readOnly }: MandatoryProps) {
	const { t } = useTranslation(I18N_NAME_SPACE);
	return (
		<Controller
			render={({ field }) => (
				<Toggle
					onChange={(event: React.BaseSyntheticEvent) => field.onChange(event.target.checked)}
					checked={field.value}
					disabled={readOnly}
					id="CAD-mandatory-toggle"
					label={t('CUSTOM_ATTRIBUTES_TOGGLE_MANDATORY_LABEL', 'Mandatory')}
					onFinish={field.onBlur}
					errorMessage={t('ERROR_OBJECT_REQUIRED', 'Missing required field')}
					data-feature="custom_attribute.mandatory"
				/>
			)}
			control={rhf.control}
			name="mandatory"
		/>
	);
}

Mandatory.displayName = 'Mandatory';
